// extracted by mini-css-extract-plugin
export default {"border":"EnergyCarousel_border__M8qDZ"};